(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-filter-bar"] && !Shopify.designMode) return;
  try {
    
function galleryFilterSlug(value) {
  return value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function galleryFilterBuildBar(bar, grids) {
  const list = bar.querySelector('[data-gallery-filter-list]');
  if (!list) return;

  if (!grids || grids.length === 0) {
    list.innerHTML = '';
    return;
  }

  const seen = new Map();
  const gridData = grids.map((grid) => {
    const items = Array.from(grid.querySelectorAll('.gallery-grid__item'));
    items.forEach((item) => {
      const tokens = [];
      (item.dataset.categories || '').split(',').forEach((part) => {
        const label = part.trim();
        if (!label) return;
        const slug = galleryFilterSlug(label);
        if (!slug) return;
        tokens.push(slug);
        if (!seen.has(slug)) seen.set(slug, label);
      });
      item.dataset.tokens = tokens.join(' ');
    });
    return { grid: grid, items: items, noResults: grid.querySelector('[data-gallery-no-results]') };
  });

  const sectionEl = bar.closest('.shopify-section') || bar.parentElement || bar;
  const resultsWrap = sectionEl.querySelector('[data-gallery-filter-results]');
  const resultsGrid = resultsWrap ? resultsWrap.querySelector('[data-gallery-filter-results-grid]') : null;
  const resultsEmpty = resultsWrap ? resultsWrap.querySelector('[data-gallery-filter-noresults]') : null;

  list.innerHTML = '';
  const allBtn = document.createElement('button');
  allBtn.type = 'button';
  allBtn.className = 'gallery-filter-bar__btn is-active';
  allBtn.dataset.filter = '*';
  allBtn.setAttribute('aria-pressed', 'true');
  allBtn.textContent = bar.dataset.allLabel || 'All';
  list.appendChild(allBtn);

  Array.from(seen.keys())
    .sort((a, b) => seen.get(a).localeCompare(seen.get(b)))
    .forEach((slug) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gallery-filter-bar__btn';
      btn.dataset.filter = slug;
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = seen.get(slug);
      list.appendChild(btn);
    });

  bar._applyFilter = function (filter) {
    // "All" -> show the original gallery section(s), hide the results panel.
    if (filter === '*') {
      gridData.forEach((data) => {
        const section = data.grid.closest('.shopify-section') || data.grid;
        section.style.display = '';
      });
      if (resultsGrid) resultsGrid.innerHTML = '';
      if (resultsWrap) resultsWrap.hidden = true;
      return;
    }

    // A category -> hide the original gallery section(s), build the results panel.
    if (resultsGrid) resultsGrid.innerHTML = '';
    let total = 0;
    let styleSource = '';

    gridData.forEach((data) => {
      const section = data.grid.closest('.shopify-section') || data.grid;
      section.style.display = 'none';
      if (!styleSource) styleSource = data.grid.getAttribute('style') || '';

      data.items.forEach((item) => {
        const tokens = (item.dataset.tokens || '').split(' ').filter(Boolean);
        if (tokens.indexOf(filter) === -1) return;
        total++;
        if (!resultsGrid) return;
        const clone = item.cloneNode(true);
        clone.classList.remove('is-hidden', 'is-hiding');
        resultsGrid.appendChild(clone);
      });
    });

    if (resultsGrid && styleSource) resultsGrid.setAttribute('style', styleSource);
    if (resultsEmpty) resultsEmpty.hidden = total !== 0;
    if (resultsWrap) resultsWrap.hidden = false;
  };

  if (bar.dataset.bound !== 'true') {
    bar.dataset.bound = 'true';
    list.addEventListener('click', (event) => {
      const btn = event.target.closest('.gallery-filter-bar__btn');
      if (!btn) return;
      list.querySelectorAll('.gallery-filter-bar__btn').forEach((b) => {
        const active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (typeof bar._applyFilter === 'function') bar._applyFilter(btn.dataset.filter);
    });
  }
}

function galleryFilterInit() {
  const bars = Array.from(document.querySelectorAll('[data-gallery-filter-bar]'));
  const grids = Array.from(document.querySelectorAll('[data-gallery-grid]'));
  const claimed = new Set();

  bars.forEach((bar) => {
    const group = (bar.dataset.galleryGroup || '').trim();
    let targets = [];

    if (group) {
      targets = grids.filter((g) => (g.dataset.galleryGroup || '').trim() === group);
    } else {
      const target = grids.find((g) => {
        if (claimed.has(g)) return false;
        if ((g.dataset.galleryGroup || '').trim() !== '') return false;
        return (bar.compareDocumentPosition(g) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
      });
      if (target) {
        claimed.add(target);
        targets = [target];
      }
    }

    galleryFilterBuildBar(bar, targets);
  });
}

if (document.readyState !== 'loading') {
  galleryFilterInit();
} else {
  document.addEventListener('DOMContentLoaded', galleryFilterInit);
}

document.addEventListener('shopify:section:load', galleryFilterInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.galleryLightboxReady) return;
  window.galleryLightboxReady = true;

  let overlay;
  let imgEl;
  let captionEl;

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'gallery-lightbox';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="gallery-lightbox__backdrop" data-gallery-lightbox-close></div>' +
      '<div class="gallery-lightbox__content">' +
      '<button type="button" class="gallery-lightbox__close" aria-label="Close" data-gallery-lightbox-close><svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg></button>' +
      '<span class="gallery-lightbox__spinner" aria-hidden="true"></span>' +
      '<img class="gallery-lightbox__img" alt="">' +
      '<p class="gallery-lightbox__caption"></p>' +
      '</div>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.gallery-lightbox__img');
    captionEl = overlay.querySelector('.gallery-lightbox__caption');

    overlay.addEventListener('click', function (event) {
      if (event.target.closest('[data-gallery-lightbox-close]')) closeLightbox();
    });
  }

  function bigSrc(img) {
    const src = img.getAttribute('src') || img.src || '';
    return src.replace(/([?&]width=)\d+/, '$11600');
  }

  function openLightbox(thumbSrc, fullSrc, alt, caption) {
    if (!overlay) buildOverlay();
    imgEl.alt = alt || '';
    captionEl.textContent = caption || '';

    // Show the already-cached thumbnail instantly so the popup never feels slow.
    imgEl.src = thumbSrc;
    overlay.removeAttribute('hidden');
    document.body.classList.add('gallery-lightbox-open');

    // Upgrade to the high-res version in the background, then swap it in.
    if (fullSrc && fullSrc !== thumbSrc) {
      overlay.classList.add('is-loading');
      const hi = new Image();
      hi.decoding = 'async';
      hi.onload = function () {
        if (overlay.hasAttribute('hidden')) return;
        imgEl.src = fullSrc;
        overlay.classList.remove('is-loading');
      };
      hi.onerror = function () {
        overlay.classList.remove('is-loading');
      };
      hi.src = fullSrc;
    } else {
      overlay.classList.remove('is-loading');
    }
  }

  function closeLightbox() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    overlay.classList.remove('is-loading');
    document.body.classList.remove('gallery-lightbox-open');
  }

  document.addEventListener('click', function (event) {
    const item = event.target.closest('.gallery-grid__item');
    if (!item) return;
    const img = item.querySelector('.gallery-grid__img');
    if (!img) return;
    event.preventDefault();
    const caption = item.querySelector('.gallery-grid__caption');
    const thumb = img.currentSrc || img.src;
    openLightbox(thumb, bigSrc(img), img.alt, caption ? caption.textContent : '');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
